import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from '../rootReducer';

/* Action Types */
export const SET_WINDOW_SIZE = 'la/ui/windowSize/SET';

export type State = {
    height: number;
    initialWidth: number;
    isMobile: boolean;
    width: number;
};

export const DEFAULT_STATE: State = {
    height: 1024,
    initialWidth: 1024,
    isMobile: false,
    width: 1024,
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}): State {
    switch (action.type) {
        case SET_WINDOW_SIZE:
            return {
                ...state,
                height: action.payload.height,
                isMobile: action.payload.width < 768,
                width: action.payload.width,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState): State => state.windowSize;

export const getWindowSize = createSelector(stateSelector, (state) => state);
export const getInitialWidth = createSelector(stateSelector, (state): number => state.initialWidth);

/* ACTION CREATORS */
type SetWindowSizeParams = {
    height: number;
    width: number;
};

export const setWindowSize = ({ height, width }: SetWindowSizeParams) => ({
    payload: { height, width },
    type: SET_WINDOW_SIZE,
});
